import { useQuery } from '@tanstack/react-query'

import { fetchNbaCard } from '../api/nbaCardApi'

import type { EnvironmentWithChina } from '../App'

interface UseNbaCardOptions {
  accountNumber: string
  env: EnvironmentWithChina
  authToken?: string
  /** Set false to hold the request back — e.g. while `NBA_cards_final` is off. */
  enabled?: boolean
}

export function useNbaCard({
  accountNumber,
  env,
  authToken,
  enabled = true,
}: UseNbaCardOptions) {
  return useQuery({
    queryKey: ['nbaCard', accountNumber, env],
    queryFn: () => fetchNbaCard(accountNumber, env, authToken),
    enabled: enabled && Boolean(accountNumber),
    staleTime: 60 * 1000,
  })
}
